<template>
  <transition name="el-fade-in-linear">
      <div class="foot" style="position: relative;">
    <div class="footer index-footer" style="height: 300px;">
      <!-- <img src="../../assets/image/picture/bgg2.jpg" class="bgg"
        style="opacity: 0.2;position: absolute;bottom: 280px;z-index: -1;width: 100%;" /> -->
      <div class="wrap">
        <div class="up">
          <div class="line"></div>
        </div>
        <div class="under">
          <ul class="clearfix">
            <li class="fl">
              <p>
                <span class="handShape">
                  <router-link to="/Mzsm">免责声明</router-link>
                  <span style="color: #ccc">｜</span>
                </span>
                <span class="handShape">
                  <router-link to="/webMap">网站地图</router-link>
                  <span style="color: #ccc">｜</span>
                </span>
                <a class="handShape">
                  <router-link to="/AboutUs">联系我们</router-link>
                </a>
              </p>
              <p>联系电话：{{ basicInfo.phone }}</p>
              <p>版权所有：{{ basicInfo.name }}</p>
              <p>技术支持：{{ basicInfo.technicalSupport }}</p>
              <p class="security">
                <a href="https://beian.miit.gov.cn/">陕ICP备17000240号-2</a>
              </p>
              <p class="copyright">
                copyright 2008 {{ basicInfo.email }} All rights reserved.
              </p>
            </li>
            <li class="fr text-right">
              <p>
                <a>
                  <img src="../../../src/assets/image/picture/1234.jpg" alt="" style="width: 22%" />
                </a>
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="allbanquan">
        <p>联系电话：{{ basicInfo.phone }}</p>
        <p>版权所有：{{ basicInfo.name }}</p>
        <p>技术支持：{{ basicInfo.technicalSupport }}</p>
        <p class="security">
          <a href="https://beian.miit.gov.cn/">陕ICP备17000240号-2</a>
        </p>
        <p class="copyright">
          copyright 2008 {{ basicInfo.email }} All rights reserved.
        </p>
      </div>
    </div>
    <!-- <el-form :rules="rules">
      <el-form-item prop="rName">
        <el-checkbox-group v-model="checkTypeList">
          <el-checkbox v-for="(item, index) in sendTypeList" :key="index" :label="item.value">{{
            item.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form> -->

  </div>
  </transition>

</template>

<script>
export default {
  data() {
    return {
      basicInfo: [],
      logoURL: "",
      // sendTypeList: [{
      //   value: 1,
      //   label: "手机短信"
      // },
      // {
      //   value: 2,
      //   label: "邮箱"
      // }],
      // checkTypeList: [1],
      // rules: {
      //   rName: [
      //     { required: true, message: '请输入活动名称', trigger: 'blur' },
      //   ]
      // }
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      let res = await this.$api.nav.getFooterInfo();
      // console.log('rrrrrrrrrrres',res);
      this.basicInfo = res.data.siteBaseInfo;
      // console.log('基本信息',this.basicInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
.handShape:hover {
  cursor: pointer;
}

.foot {
  width: 100%;
  position: relative;
}

.wrap {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
}

body {
  background: #ffffff;
  overflow-x: hidden;
}

/*公共样式*/
.text-right {
  text-align: right;
}

.text-right p a {
  margin-left: 25px;
}

/*footer*/
.footer {
  height: 280px;
  background: rgb(28, 116, 205);
  background: rgba(28, 116, 205, 0.9);
  margin-top: 20px;
  /* position: relative; */
  /* position: absolute; */
}

.footer .wrap {
  position: absolute;
  /* bottom: 75%; */
  left: 50%;
  transform: translateX(-50%);
}

.footer .up ul li h3 a {
  font-size: 22px;
}

.footer .up {
  /* background: rgba(250, 250, 250, .95); */
  padding: 10px 0 30px;
  width: 100%;
  max-height: 400px;
  position: relative;
}

.footer .up .line {
  width: 100%;
  height: 1px;
  position: absolute;
  top: 16.8%;
  left: 15px;
}

.footer .up ul li {
  padding: 0 10px;
}

.footer .up ul li a {
  display: block;
  line-height: 36px;
  color: #323232;
  font-size: 16px;
  padding-left: 20px;
}

.footer .up ul li .txt a {
  padding-left: 0;
}

.footer .up ul li a:hover {
  color: #bd1b2d;
}

.footer .under {
  padding: 30px 0;
  width: 100%;
  position: absolute;
}

.footer .under ul {
  display: flex;
  align-items: center;
}

.footer .under ul li {
  width: 100%;
}

.footer .under p,
.under a {
  color: #fff;
  font-size: 15px;
  line-height: 32px;
  letter-spacing: 1px;
  margin-bottom: 5px;
}

.footer .under a i {
  color: #e27478;
}

.footer .under .security {
  background: url(../../../src/assets/image/picture/icon_gongan.png) no-repeat;
  padding-left: 28px;
  background-position: 0;
}

.allbanquan {
  display: none;
}

@media screen and (max-width: 768px) {
  .footer {
    height: auto !important;
    .wrap {
      width: 100% !important;
    }

    // height: 16rem;
    text-align: left;

    .up,
    .line {
      display: none;
    }

    .under {
      display: none !important;
    }

    img {
      display: none !important;
    }

    .allbanquan {
      display: flex;
      flex-direction: column;
      // align-items: center;
      color: #fff;
      font-size: 16px;
      padding: 20px;

      p {
        padding: 5px 0;
      }

      a {
        color: #fff;
      }
    }
  }

  .fl p {
    display: none !important;
  }

  .text-right {
    display: none !important;
  }
}

.transition-box {
    margin-bottom: 10px;
    width: 200px;
    height: 100px;
    border-radius: 4px;
    background-color: #409EFF;
    text-align: center;
    color: #fff;
    padding: 40px 20px;
    box-sizing: border-box;
    margin-right: 20px;
  }
</style>

